/** Figma `37:896` — Signal Provider List table page layout tokens. */
import { SENSEMAKER_TABLE } from '@/shared/table/sensemaker-table-theme'

export {
  APP_SHELL_PAGE_TITLE_SUBTITLE_GAP_PX as SP_LIST_TITLE_SUBTITLE_GAP_PX,
  APP_SHELL_PAGE_TITLE_ROW_MARGIN_BOTTOM_PX as SP_LIST_TITLE_ROW_TO_PILLS_GAP_PX,
} from '@/shared/layout/appShellPageLayout'
export {
  SENSEMAKER_LIST_FILTER_GAP_PX as SP_LIST_FILTER_GAP_PX,
  SENSEMAKER_LIST_PILLS_TO_GRID_GAP_PX as SP_LIST_PILLS_TO_TABLE_GAP_PX,
} from '@/features/tenants/lib/sensemaker-list-layout'

export const SP_LIST_FILTER_WIDTH_PX = 225
export const SP_LIST_FILTER_LABEL_VALUE_GAP_PX = 10
export const SP_LIST_PILL_GAP_PX = 8
export const SP_LIST_TABLE_BORDER = SENSEMAKER_TABLE.rowBorder
export const SP_LIST_TABLE_HEADER_BG = SENSEMAKER_TABLE.headerBg
export const SP_LIST_TABLE_HEADER_COLOR = SENSEMAKER_TABLE.headerText
export const SP_LIST_TABLE_SORT_ACTIVE_COLOR = SENSEMAKER_TABLE.sortActiveColor
export const SP_LIST_TABLE_RADIUS_PX = 10
export const SP_LIST_TABLE_CELL_H_PADDING_PX = SENSEMAKER_TABLE.cellPaddingPx
export const SP_LIST_TABLE_HEADER_ROW_PY_PX = SENSEMAKER_TABLE.headerRowPyPx
export const SP_LIST_TABLE_BODY_ROW_HEIGHT_PX = SENSEMAKER_TABLE.rowMinHeight
export const SP_LIST_TABLE_PAGINATION_TOP_GAP_PX = 32
export const SP_LIST_DEFAULT_ROWS_PER_PAGE = 20
export const SP_LIST_ROWS_PER_PAGE_OPTIONS = [10, 20, 50] as const
